import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  moreResults: {
    id: 'faq.moreResults',
    defaultMessage: 'More Results',
  },
  ifAnswered: {
    id: 'faq.ifAnswered',
    defaultMessage: 'Did this answer your question?',
  },
  note: {
    id: 'faq.note',
    defaultMessage:
      'Note: click yes to return to the FAQ; click no to contact us.',
  },
  yesCta: {
    id: 'faq.yesCta',
    defaultMessage: 'Yes',
  },
  noCta: {
    id: 'faq.noCta',
    defaultMessage: 'No',
  },
  allTheQuestions: {
    id: 'faq.categories.allTheQuestions',
    defaultMessage: 'All The Questions',
  },
});
